import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import { StaticQuery, graphql, withPrefix } from "gatsby"

import Header from '../components/generals/Header'
import Disclaimer from '../components/generals/Disclaimer'

import 'typeface-roboto'
import 'typeface-roboto-mono'

import './normalize.css'
import './index.css'

// import AppleLaunch1 from '../assets/icons/apple-launch/apple-launch-640x1136.png'
import AppleLaunch2 from '../assets/icons/apple-launch/apple-launch-750x1294.png'

// import AppleLaunch3 from '../assets/icons/apple-launch/apple-launch-1125x2436.png'
// import AppleLaunch4 from '../assets/icons/apple-launch/apple-launch-1242x2208.png'
// import AppleLaunch5 from '../assets/icons/apple-launch/apple-launch-1536x2048.png'
// import AppleLaunch6 from '../assets/icons/apple-launch/apple-launch-1668x2224.png'
// import AppleLaunch7 from '../assets/icons/apple-launch/apple-launch-2048x2732.png'

class Layout extends React.Component {
  state = {
    disclaimerVisibility: false
  }

  toggleDisclaimer = () => {
    this.setState({
      disclaimerVisibility: !this.state.disclaimerVisibility
    });
  }

  render() {
    const { children, location } = this.props;

    return (
      <StaticQuery
        query={graphql`
          query SiteTitleQuery {
            site {
              siteMetadata {
                title
              }
            }
          }
        `}
        render={data => (
          <>
            <Helmet
              title={data.site.siteMetadata.title}
              meta={[
                { name: 'description', content: 'Sample' },
                { name: 'keywords', content: 'sample, something' },
                { name: 'viewport', content: 'user-scalable=no, initial-scale=1, maximum-scale=1, minimum-scale=1, width=device-width, height=device-height' },
                { name: 'apple-mobile-web-app-capable', content: 'yes' },
                { name: 'apple-mobile-web-app-status-bar-style', content: 'black' },
                { name: 'apple-mobile-web-app-title', content: 'Ozzero' },
                { name: 'theme-color', content: '#0b33f8' },
                { name: 'msapplication-TileColor', content: '#0b33f8' }
              ]}
            >
              <html lang="it" />

              <link href={withPrefix('/app-icons/favicons/favicon-16x16.png')} rel="icon" type="image/png" sizes="16x16" />
              <link href={withPrefix('/app-icons/favicons/favicon-32x32.png')} rel="icon" type="image/png" sizes="32x32" />

              <link href={withPrefix('/app-icons/touch-icons/safari-pinned-tab.svg')} rel="mask-icon" color="#0b33f8"/>

              <link href={withPrefix('/app-icons/touch-icons/apple-touch-icon-57x57.png')} rel="apple-touch-icon" sizes="57x57"/>
              <link href={withPrefix('/app-icons/touch-icons/apple-touch-icon-60x60.png')} rel="apple-touch-icon" sizes="60x60"/>
              <link href={withPrefix('/app-icons/touch-icons/apple-touch-icon-72x72.png')} rel="apple-touch-icon" sizes="72x72"/>
              <link href={withPrefix('/app-icons/touch-icons/apple-touch-icon-76x76.png')} rel="apple-touch-icon" sizes="76x76"/>
              <link href={withPrefix('/app-icons/touch-icons/apple-touch-icon-114x114.png')} rel="apple-touch-icon" sizes="114x114"/>
              <link href={withPrefix('/app-icons/touch-icons/apple-touch-icon-120x120.png')} rel="apple-touch-icon" sizes="120x120"/>
              <link href={withPrefix('/app-icons/touch-icons/apple-touch-icon-144x144.png')} rel="apple-touch-icon" sizes="144x144"/>
              <link href={withPrefix('/app-icons/touch-icons/apple-touch-icon-152x152.png')} rel="apple-touch-icon" sizes="152x152"/>
              <link href={withPrefix('/app-icons/touch-icons/apple-touch-icon-180x180.png')} rel="apple-touch-icon" sizes="180x180"/>
              <link href={withPrefix('/app-icons/touch-icons/apple-touch-icon.png')} rel="apple-touch-icon"/>

              <link rel={AppleLaunch2} href="images/splash/launch-750x1294.png" media="(device-width: 375px) and (device-height: 667px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)" />
            </Helmet>
            <Header location={location} />
            <div>
              {children}
            </div>
            {this.state.disclaimerVisibility &&
              <Disclaimer toggleDisclaimer={this.toggleDisclaimer}/>
            }
          </>
        )}
      />
    )
  }
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout